/**
 * @generated SignedSource<<b5c37011b6201af3b1444cffda7930dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportCommentsStatisticsCardFragment$data = {
  readonly commentsReport: {
    readonly allTime: number;
    readonly sinceYesterday: number | null;
  };
  readonly " $fragmentType": "MemberReportCommentsStatisticsCardFragment";
};
export type MemberReportCommentsStatisticsCardFragment$key = {
  readonly " $data"?: MemberReportCommentsStatisticsCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportCommentsStatisticsCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportCommentsStatisticsCardFragment",
  "selections": [
    {
      "alias": "commentsReport",
      "args": [
        {
          "kind": "Literal",
          "name": "entities",
          "value": [
            "CurriculumItem",
            "Assignment",
            "AssignmentSubmission",
            "Lesson",
            "Task",
            "Post"
          ]
        },
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "commented"
          ]
        },
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "userActivityReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sinceYesterday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "320e0b69a8fdb2a9953183048eeacc66";

export default node;
